import { GraphQLQuery } from '@settings/services/graphQLClient/GraphQLClient';
import gql from 'graphql-tag';

import { Order } from '../interface';

export type _OrderMutationVar = {
  order_products: {
    price: number;
    amount: number;
    data: string;
    product_type: string;
  }[];
  customer_id: string;
  currency_id: number;
  language_id: number;
  comment: string;
};

// Мутация на создание заказа
export class CreateOrderMutation
  implements
    GraphQLQuery<{
      preOrderId: number;
      order: _OrderMutationVar;
    }>
{
  readonly query: any;

  readonly variables: {
    preOrderId: number;
    order: _OrderMutationVar;
  };

  constructor(preOrderId: string, order: Order) {
    this.variables = {
      preOrderId: Number(preOrderId),
      order: {
        comment: order.comment,
        currency_id: Number(order.currency_id),
        language_id: Number(order.language_id),
        order_products: order.products.map(({ id, ...otherProps }) => ({
          order_id: null,
          id: Number(id),
          product_type: otherProps.product_type,
          price: otherProps.price,
          amount: otherProps.amount,
          data: otherProps.data,
          token: otherProps.token,
        })),
        customer_id: order.customer_id,
      },
    };

    this.query = gql`
      mutation __CREATE_ORDER__($preOrderId: ID, $order: Order_Complete_Data!) {
        data: order_create(order: $order, pre_order_id: $preOrderId) {
          currency_id
          currency_nominal
          currency_rate
          customer_id
          date
          id
          language_id
          order_price
          order_products {
            amount
            data
            id
            order_id
            price
            product_type
            token
          }
        }
      }
    `;
  }
}
